"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsProvider = SettingsProvider;
exports.useSettings = useSettings;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var SettingsContext = /*#__PURE__*/_react["default"].createContext();

function SettingsProvider(_ref) {
  var settings = _ref.settings,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(SettingsContext.Provider, {
    value: settings || {}
  }, children);
}

function useSettings() {
  var context = _react["default"].useContext(SettingsContext);

  if (context === undefined) {
    throw new Error('useSettings must be used with SettingsProvider');
  }

  return context;
}